import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconTeams = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9248 10.9667C18.615 10.3661 19.5325 10 20.5393 10C22.6852 10 24.4248 11.6629 24.4248 13.7143C24.4248 15.7656 22.6852 17.4286 20.5393 17.4286C19.5325 17.4286 18.615 17.0625 17.9248 16.4619",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9248 19.3879C19.3871 19.0327 20.9297 19 20.9297 19C20.9297 19 25.3371 19.0933 26.3143 20.6801C26.7067 21.3172 26.9248 24.7908 26.9248 26H20.1295",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.2506,
			cy: 13.819,
			r: 3.81115,
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9531 25.9871H9.58187C9.60061 25.2826 9.65356 24.2788 9.73787 23.3217C9.79141 22.714 9.85687 22.1337 9.93267 21.6659C9.97062 21.4317 10.0101 21.2324 10.0502 21.0752C10.0927 20.9083 10.1276 20.8235 10.1437 20.7951C10.3203 20.4852 10.6826 20.2028 11.211 19.9622C11.7303 19.7258 12.3519 19.556 12.964 19.4361C13.5729 19.3169 14.1544 19.2505 14.585 19.2141C14.7997 19.1959 14.9757 19.1853 15.0971 19.1792C15.1578 19.1762 15.2048 19.1743 15.2362 19.1732L15.2697 19.1721L15.3033 19.1732C15.3346 19.1743 15.3816 19.1762 15.4423 19.1792C15.5638 19.1853 15.7397 19.1959 15.9545 19.2141C16.3851 19.2505 16.9665 19.3169 17.5755 19.4361C18.1875 19.556 18.8091 19.7258 19.3285 19.9622C19.8568 20.2028 20.2192 20.4852 20.3957 20.7951C20.4118 20.8234 20.4466 20.908 20.489 21.0749C20.529 21.232 20.5683 21.4313 20.606 21.6655C20.6814 22.1333 20.7463 22.7135 20.7992 23.3213C20.8827 24.2784 20.9347 25.2824 20.9531 25.9871Z",
			stroke: "#1D1D1D"
		})
	]
});
export default SvgNaviconTeams;
